import { useState } from 'react'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * 📋 Chép nhanh mã đơn cạnh mã (bản cũ `CopyRef`, `Az.tsx:1007`) — mờ đi, rê vào mới đậm; bấm xong đổi dấu ✓ xanh.
 * Dùng chung cho Đơn hàng (`/az/sales`) và Danh sách vận hành (`/az/ops`) — bản cũ cũng một component cho cả hai.
 * ⚠ Nhãn thuộc nhóm chuỗi `sales` — cả hai màn đều nạp nhóm đó.
 * Icon vẽ thẳng SVG nét lucide `Copy` / `Check` thay emoji 📋 / ✅ cho gọn mắt (user 30/10) — không kéo
 * `lucide-react` vào `apps/web`, cùng lý do `dash-icons.tsx`.
 */
export const CopyRef = ({ text, className = '' }: { text: string; className?: string }): JSX.Element | null => {
  const { t } = useTranslation()
  const [done, setDone] = useState(false)
  if (text === '') return null
  return (
    <button type="button" title={done ? t('sales.table.copiedTitle') : t('sales.table.copyRefTitle', { ref: text })}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              void navigator.clipboard?.writeText(text)
              setDone(true)
              setTimeout(() => { setDone(false) }, 1200)
            }}
            className={`inline-flex shrink-0 items-center justify-center align-middle leading-none transition-colors ${done ? 'text-emerald-600' : 'text-slate-400 hover:text-sky-600'} ${className}`}>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
           strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        {done
          ? <path d="M20 6 9 17l-5-5" />
          : <><rect x="8" y="8" width="14" height="14" rx="2" ry="2" /><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" /></>}
      </svg>
    </button>
  )
}
